import { render, staticRenderFns } from "./SimpleTooltip.vue?vue&type=template&id=8fd89f2c&"
import script from "./SimpleTooltip.vue?vue&type=script&lang=js&"
export * from "./SimpleTooltip.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTooltip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports